<template>
  <v-container>
    <div class="row">
      <div class="col-md-10 col-sm-12 col-xs-12">
        <v-card class="top">
          <v-layout row>
            <v-flex md9 sm9 xs9>
              <v-text-field
                label="Ideas de Fuerzas"
                @click="pickFile('0')"
                v-model="FileName[0]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][0]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file0"
                ref="myFiles0"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('0')"
                multiple
              />
            </v-flex>

            <v-flex md2 sm1 xs1>
              <v-btn
                v-if="this.filesDge['dge'][0]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('0')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][0]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('0')"
                :disabled="disabled[0]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="PEI 2018-2020"
                @click="pickFile('6')"
                v-model="FileName[6]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][6]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file6"
                ref="myFiles6"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('6')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][6]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('6')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][6]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('6')"
                :disabled="disabled[6]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Resultado encuesta"
                @click="pickFile('9')"
                v-model="FileName[9]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][9]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file9"
                ref="myFiles9"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('9')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][9]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('9')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][9]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('9')"
                :disabled="disabled[9]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Metodología PEI"
                @click="pickFile('8')"
                v-model="FileName[8]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][8]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file8"
                ref="myFiles8"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('8')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][8]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('8')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][8]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('8')"
                :disabled="disabled[8]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 sm9 xs9>
              <v-text-field
                label="Resumen de diagnostico"
                @click="pickFile('1')"
                v-model="FileName[1]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][1]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file1"
                ref="myFiles1"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('1')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][1]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('1')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][1]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('1')"
                :disabled="disabled[1]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevista de Autoridades"
                @click="pickFile('2')"
                v-model="FileName[2]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][2]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file2"
                ref="myFiles2"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('2')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][2]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('2')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][2]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('2')"
                :disabled="disabled[2]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevistas grupales"
                @click="pickFile('3')"
                v-model="FileName[3]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][3]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file3"
                ref="myFiles3"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('3')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][3]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('3')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][3]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('3')"
                :disabled="disabled[3]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Informe PESTEL"
                @click="pickFile('4')"
                v-model="FileName[4]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][4]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file4"
                ref="myFiles4"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('4')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][4]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('4')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][4]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('4')"
                :disabled="disabled[4]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Entrevista academico"
                @click="pickFile('7')"
                v-model="FileName[7]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][7]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file7"
                ref="myFiles7"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('7')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][7]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('7')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][7]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('7')"
                :disabled="disabled[7]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Diagnostico 16-20"
                @click="pickFile('10')"
                v-model="FileName[10]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][10]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file10"
                ref="myFiles10"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('10')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][10]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('10')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][10]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('10')"
                :disabled="disabled[10]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="Informe de Tendencias"
                @click="pickFile('5')"
                v-model="FileName[5]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][5]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file5"
                ref="myFiles5"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('5')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][5]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('5')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][5]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('5')"
                :disabled="disabled[5]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                label="ODS"
                @click="pickFile('11')"
                v-model="FileName[11]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][11]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file11"
                ref="myFiles11"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('11')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][11]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('11')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][11]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('11')"
                :disabled="disabled[11]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][12]['nombre_archivo']"
                @click="pickFile('12')"
                v-model="FileName[12]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][12]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file12"
                ref="myFiles12"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('12')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][12]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('12')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][12]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('12')"
                :disabled="disabled[12]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][13]['nombre_archivo']"
                @click="pickFile('13')"
                v-model="FileName[13]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][13]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file13"
                ref="myFiles13"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('13')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][13]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('13')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][13]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('13')"
                :disabled="disabled[13]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][14]['nombre_archivo']"
                @click="pickFile('14')"
                v-model="FileName[14]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][14]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file14"
                ref="myFiles14"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('14')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][14]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('14')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][14]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('14')"
                :disabled="disabled[14]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][15]['nombre_archivo']"
                @click="pickFile('15')"
                v-model="FileName[15]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][15]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file15"
                ref="myFiles15"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('15')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][15]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('15')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][15]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('15')"
                :disabled="disabled[15]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][16]['nombre_archivo']"
                @click="pickFile('16')"
                v-model="FileName[16]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][16]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file16"
                ref="myFiles16"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('16')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][16]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('16')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][16]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('16')"
                :disabled="disabled[16]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][17]['nombre_archivo']"
                @click="pickFile('17')"
                v-model="FileName[17]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][17]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file17"
                ref="myFiles17"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('17')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][17]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('17')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][17]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('17')"
                :disabled="disabled[17]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][18]['nombre_archivo']"
                @click="pickFile('18')"
                v-model="FileName[18]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][18]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file18"
                ref="myFiles18"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('18')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][18]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('18')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][18]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('18')"
                :disabled="disabled[18]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][19]['nombre_archivo']"
                @click="pickFile('19')"
                v-model="FileName[19]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][19]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file19"
                ref="myFiles19"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('19')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][19]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('19')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][19]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('19')"
                :disabled="disabled[19]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][20]['nombre_archivo']"
                @click="pickFile('20')"
                v-model="FileName[20]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][20]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file20"
                ref="myFiles20"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('20')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][20]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('20')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][20]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('20')"
                :disabled="disabled[20]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][21]['nombre_archivo']"
                @click="pickFile('21')"
                v-model="FileName[21]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][21]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file21"
                ref="myFiles21"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('21')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][21]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('21')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][21]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('21')"
                :disabled="disabled[21]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][22]['nombre_archivo']"
                @click="pickFile('22')"
                v-model="FileName[22]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][22]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file22"
                ref="myFiles22"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('22')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][22]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('22')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][22]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('22')"
                :disabled="disabled[22]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][23]['nombre_archivo']"
                @click="pickFile('23')"
                v-model="FileName[23]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][23]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file23"
                ref="myFiles23"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('23')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][23]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('23')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][23]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('23')"
                :disabled="disabled[23]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][24]['nombre_archivo']"
                @click="pickFile('24')"
                v-model="FileName[24]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][24]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file24"
                ref="myFiles24"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('24')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][24]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('24')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][24]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('24')"
                :disabled="disabled[24]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][25]['nombre_archivo']"
                @click="pickFile('25')"
                v-model="FileName[25]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][25]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file25"
                ref="myFiles25"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('25')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][25]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('25')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][25]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('25')"
                :disabled="disabled[25]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][26]['nombre_archivo']"
                @click="pickFile('26')"
                v-model="FileName[26]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][26]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file26"
                ref="myFiles26"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('26')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][26]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('26')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][26]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('26')"
                :disabled="disabled[26]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][27]['nombre_archivo']"
                @click="pickFile('27')"
                v-model="FileName[27]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][27]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file27"
                ref="myFiles27"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('27')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][27]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('27')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][27]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('27')"
                :disabled="disabled[27]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][28]['nombre_archivo']"
                @click="pickFile('28')"
                v-model="FileName[28]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][28]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file28"
                ref="myFiles28"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('28')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][28]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('28')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][28]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('28')"
                :disabled="disabled[28]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][29]['nombre_archivo']"
                @click="pickFile('29')"
                v-model="FileName[29]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][29]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file29"
                ref="myFiles29"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('29')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][29]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('29')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][29]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('29')"
                :disabled="disabled[29]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
         <v-card>
          <v-layout row>
            <v-flex md9 xs9>
              <v-text-field
                :label="this.filesDge['dge'][30]['nombre_archivo']"
                @click="pickFile('30')"
                v-model="FileName[30]"
                prepend-icon="attach_file"
                :disabled="this.filesDge['dge'][30]['saved'] == 'si'"
              ></v-text-field>
              <input
                type="file"
                id="file30"
                ref="myFiles30"
                style="display: none"
                class="custom-file-input"
                @change="previewFiles('30')"
                multiple
              />
            </v-flex>

            <v-flex md2 xs1>
              <v-btn
                v-if="this.filesDge['dge'][30]['saved'] == 'si'"
                fab
                outline
                small
                color="#394049"
                v-on:click="downloadFile('30')"
              >
                <v-icon dark>save_alt</v-icon>
              </v-btn>
              <v-btn
                v-if="this.filesDge['dge'][30]['saved'] == 'no'"
                fab
                outline
                small
                color="#EC6A12"
                v-on:click="submitFile('30')"
                :disabled="disabled[30]"
              >
                <v-icon color="#394049" dark>publish</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </div>
  </v-container>
</template>


<script>
export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      path: "",
      disabled: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      file: "",
      filesDge: "",
      filess: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
        7: "",
        8: "",
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: "",
        15: "",
        16: "",
        17: "",
        18: "",
        19: "",
        20: "",
        21: "",
        22: "",
        23: "",
        24: "",
        25: "",
        26: "",
        27: "",
        28: "",
        29: "",
        30: ""
      },
      FileName: {
        0: "",
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: "",
        7: "",
        8: "",
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: "",
        15: "",
        16: "",
        17: "",
        18: "",
        19: "",
        20: "",
        21: "",
        22: "",
        23: "",
        24: "",
        25: "",
        26: "",
        27: "",
        28: "",
        29: "",
        30: ""
      }
    };
  },

  created() {
    //console.log(this.auth);

    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDge = response.data;
        //console.log(this.filesDge);
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    /*
        Submits the file to the server
      */
    submitFile(index) {
      /*
                Initialize the form data
            */

      let formData = new FormData();
      var name = this.filess[index].name;
      //console.log("indice: " + index);
      /*
                Add the form data we need to submit
            */
      formData.append("file", this.filess[index]);
      //console.log(formData);

      /*
          Make the request to the POST /single-file URL
        */

      axios
        .post(
          process.env.ROOT_API + "/uploadFileDcaEtc/createFile?cc=0",
          formData,
          this.auth
        )
        .then(response => {
          //console.log("SUCCESS!!");
          //console.log(response.data);
          this.path = response.data;
          this.filesDge.dge[index]["saved"] = "si";
          this.filesDge.dge[index]["path"] = response.data[0];
          this.filesDge.dge[index]["name"] = response.data[1];
          alert("Archivo: " + name + " fue cargado exitosamente.");
        })
        .catch(error => {
          //console.log("FAILURE!!");
          alert("Error al cargar el archivo" + name + " ," + error);
        })
        .then(response => {
          axios
            .post(
              process.env.ROOT_API +
                "/uploadFileDcaEtc/updateFileValue?ccValor=0&tipoData=dge",
              this.filesDge.dge,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
              //console.log("funcionando");
            })
            .catch(error => {
              console.error(error);
            });
        });
    },

    /*
        Handles a change on the file upload
      */
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      //console.log(this.file);
    },

    previewFiles(index) {
      //console.log(index);
      this.filess[index] = this.$refs["myFiles" + index].files[0];
      //console.log(this.filess);
      this.FileName[index] = this.$refs["myFiles" + index].files[0].name;
    },
    pickFile(index) {
      //console.log("entrando a pick file");
      this.$refs["myFiles" + index].click();
      this.disabled[index] = false;
    },

    // TODO
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },

    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.primary--text {
  color: #ec6a12 !important;
  caret-color: #ec6a12 !important;
}

.v-text-field .v-label--active {
  color: #ec6a12 !important;
}

.v-btn--floating.v-btn--small {
  height: 35px !important;
  width: 35px !important;
  margin-top: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/primeraEtapa/Dge.vue